import React from 'react';
import { X, Clock, Shield, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const AdminApprovalModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="bg-gradient-to-b from-[#1a1a2e] to-[#0f0f1a] rounded-2xl border border-amber-500/30 shadow-2xl shadow-amber-500/20 max-w-md w-full mx-4 overflow-hidden">
        {/* Header */}
        <div className="relative p-6 pb-4 border-b border-[#2a2a4a]">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-[#6b7a99] hover:text-white transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
          
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-xl bg-amber-500/20 border border-amber-500/30">
              <Clock className="w-8 h-8 text-amber-400" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white">Pending Approval</h2>
              <p className="text-[#8a8a9a] text-sm">Your account is under review</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="flex items-start gap-3 p-4 rounded-xl bg-amber-500/10 border border-amber-500/20">
            <Shield className="w-5 h-5 text-amber-400 mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-amber-300 text-sm font-medium">Account Verification Required</p>
              <p className="text-[#8a8a9a] text-xs mt-1">
                Your account has been created successfully but requires admin approval to access premium features.
              </p>
            </div>
          </div>

          <div className="text-center space-y-3">
            <p className="text-[#a0a0b0] text-sm">
              Please wait for the admin to verify and approve your account. 
              This usually takes <span className="text-cyan-400 font-medium">24-48 hours</span>.
            </p>
            
            <div className="flex items-center justify-center gap-2 text-[#6b7a99] text-xs">
              <MessageCircle className="w-4 h-4" />
              <span>For faster approval, contact admin via Telegram</span>
            </div>
          </div>

          {/* Contact Options */}
          <div className="grid grid-cols-2 gap-3 pt-2">
            <a
              href="https://t.me/AlphaTradeVission"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-[#0088cc]/20 border border-[#0088cc]/30 text-[#0088cc] hover:bg-[#0088cc]/30 transition-colors text-sm font-medium"
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
              </svg>
              Telegram
            </a>
            <Button
              onClick={onClose}
              className="bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-700 hover:to-blue-700 text-white font-medium"
            >
              Got it
            </Button>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-[#0a0a15] border-t border-[#2a2a4a]">
          <p className="text-[#5a5a6a] text-xs text-center">
            You can view the dashboard while waiting for approval. 
            Feature access will be enabled once approved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminApprovalModal;
